/* Comportements des sections clone-lvn-* (remplacent Swiper, Kaching Bundles et les scripts du thème Luveon d'origine). */
(() => {
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  /* ---------- cartes produit : pastilles couleur → image ---------- */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-lma-product-card-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-lma-product-card]');
    const img = card && card.querySelector('.lma-product-card__image');
    $$(card, '[data-lma-product-card-swatch]').forEach((s) => s.setAttribute('aria-pressed', String(s === swatch)));
    if (img && swatch.dataset.imageSrc) {
      img.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) img.srcset = swatch.dataset.imageSrcset;
    }
    if (swatch.dataset.productUrl) $$(card, '[data-lma-product-card-link]').forEach((a) => (a.href = swatch.dataset.productUrl));
  });

  /* ---------- carrousel d'avis : flèches ---------- */
  const initCarousels = (root) => $$(root, '[data-lvn-carousel]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const track = el.querySelector('[data-lvn-carousel-track]');
    const prev = el.querySelector('[data-lvn-carousel-prev]');
    const next = el.querySelector('[data-lvn-carousel-next]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.lma-review-carousel__card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    const update = () => {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------- témoignages vidéo : lecture / son ---------- */
  const initVideos = (root) => $$(root, '[data-lvn-vt-card]').forEach((card) => {
    if (card.dataset.ready) return;
    card.dataset.ready = '1';
    const video = card.querySelector('video');
    if (!video) return;
    video.muted = true;
    const play = () => {
      $$(document, '[data-lvn-vt-card].is-playing').forEach((other) => {
        if (other === card) return;
        const v = other.querySelector('video');
        v && v.pause();
        other.classList.remove('is-playing');
      });
      video.play().then(() => card.classList.add('is-playing')).catch(() => {});
    };
    card.addEventListener('click', (event) => {
      if (event.target.closest('[data-lvn-vt-sound]')) {
        video.muted = !video.muted;
        card.classList.toggle('is-unmuted', !video.muted);
        if (video.paused) play();
        return;
      }
      if (video.paused) play();
      else { video.pause(); card.classList.remove('is-playing'); }
    });
  });

  /* ---------- page avis : filtres + voir plus ---------- */
  const initReviews = (root) => $$(root, '[data-lvn-reviews]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const btns = $$(el, '[data-rp-filter]');
    const cards = $$(el, '[data-rp-product]');
    const more = el.querySelector('[data-rp-more]');
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => x.classList.toggle('is-active', x === b));
      const f = b.dataset.rpFilter;
      if (more) more.style.display = 'none';
      cards.forEach((c) => (c.hidden = f !== 'all' && c.dataset.rpProduct !== f));
    }));
    more && more.addEventListener('click', () => {
      cards.forEach((c) => (c.hidden = false));
      more.style.display = 'none';
    });
  });

  /* ---------- grille collection : filtres tag/couleur + tri ---------- */
  const initCollection = (root) => $$(root, '[data-lvn-collection-grid]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const items = $$(el, '[data-lma-product-grid-item]');
    const inputs = $$(el, '[data-lma-filter-input]');
    const drawer = el.querySelector('[data-lma-filter-drawer]');
    const apply = () => {
      const active = { tag: new Set(), color: new Set() };
      inputs.filter((i) => i.checked).forEach((i) => active[i.dataset.filterGroup].add(i.value));
      let visible = 0;
      items.forEach((item) => {
        const okTag = !active.tag.size || [...active.tag].some((t) => item.dataset.productTags.includes(`|${t}|`));
        const okColor = !active.color.size || [...active.color].some((c) => item.dataset.productColors.includes(`|${c}|`));
        item.hidden = !(okTag && okColor);
        if (!item.hidden) visible++;
      });
      $$(el, '[data-lma-product-count]').forEach((n) => (n.textContent = visible));
      const label = el.querySelector('[data-lma-product-count-label]');
      if (label) label.textContent = `${visible} produit${visible > 1 ? 's' : ''}`;
      const empty = el.querySelector('[data-lma-filter-empty]');
      if (empty) empty.hidden = visible > 0;
      $$(el, '.lma-collection-filter__clear').forEach((b) => (b.hidden = !(active.tag.size || active.color.size)));
    };
    inputs.forEach((input) => input.addEventListener('change', () => {
      // les filtres existent en double (barre latérale + tiroir mobile) : on synchronise
      inputs.filter((i) => i !== input && i.value === input.value && i.dataset.filterGroup === input.dataset.filterGroup)
        .forEach((i) => (i.checked = input.checked));
      apply();
    }));
    $$(el, '[data-lma-filter-clear]').forEach((b) => b.addEventListener('click', () => { inputs.forEach((i) => (i.checked = false)); apply(); }));
    const toggle = (open) => {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('lma-filter-drawer-open', open);
    };
    $$(el, '[data-lma-filter-open]').forEach((b) => b.addEventListener('click', () => toggle(true)));
    $$(el, '[data-lma-filter-close]').forEach((b) => b.addEventListener('click', () => toggle(false)));
    const sort = el.querySelector('[data-lma-collection-sort]');
    sort && sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- fenêtres (guide des tailles) ---------- */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lvn-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lvnModalOpen);
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-lvn-modal-close]')) event.target.closest('dialog').close();
    else if (event.target.tagName === 'DIALOG' && event.target.classList.contains('lvn-modal')) event.target.close();
  });

  /* ---------- estimation de livraison (dates du jour côté client) ---------- */
  const initDelivery = (root) => $$(root, '[data-lvn-delivery]').forEach((el) => {
    const day = (n) => { const d = new Date(); d.setDate(d.getDate() + Number(n)); return d; };
    const dm = (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
    const min = day(el.dataset.min), max = day(el.dataset.max);
    const dates = el.querySelector('[data-lvn-delivery-dates]');
    if (dates) dates.textContent = `${dm(min)}/${min.getFullYear()} - ${dm(max)}/${max.getFullYear()}`;
    const steps = $$(el, '[data-lvn-delivery-step]');
    if (steps[0]) steps[0].textContent = dm(day(0));
    if (steps[1]) steps[1].textContent = dm(day(el.dataset.ship));
    if (steps[2]) steps[2].textContent = `${dm(min)} - ${dm(max)}`;
  });

  /* ---------- offre quantité (remplace Kaching Bundles) ---------- */
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withSep = (sep, decSep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + decSep + dec;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_with_comma_separator') return withSep('.', ',');
      if (key === 'amount_no_decimals') return int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_no_decimals_with_comma_separator') return int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withSep(',', '.');
    });
  };

  const initBundles = (root) => $$(root, '[data-lvn-bundle]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const data = JSON.parse(el.querySelector('[data-lvn-bundle-json]').textContent);
    const form = document.getElementById(el.dataset.form);
    const rowTpl = el.querySelector('[data-lvn-bundle-row]');
    const labels = el.querySelector('[data-lvn-bundle-labels]');
    const bars = $$(el, '[data-lvn-bundle-bar]');
    const findVariant = (values) => data.variants.find((v) => v.options.every((o, i) => o === values[i]));

    const rowVariant = (row) => findVariant($$(row, 'select').map((s) => s.value));
    const activeBar = () => bars.find((b) => b.classList.contains('is-active')) || bars[0];

    const refresh = () => {
      const bar = activeBar();
      const rows = $$(bar, '.lvn-bundle__row');
      const first = rows.length ? rowVariant(rows[0]) : null;
      rows.forEach((row) => {
        const dot = row.querySelector('[data-lvn-bundle-dot]');
        const colorSelect = dot && dot.parentElement.querySelector('select');
        if (dot && colorSelect) dot.style.background = colorSelect.selectedOptions[0].dataset.color;
        const v = rowVariant(row);
        row.classList.toggle('is-unavailable', !v || !v.available);
      });
      const unit = first ? first.price : null;
      if (unit !== null) bars.forEach((b) => {
        const buy = Number(b.dataset.buy), qty = Number(b.dataset.qty);
        b.querySelector('[data-lvn-bundle-total]').textContent = formatMoney(unit * buy, data.moneyFormat);
        const cmp = b.querySelector('[data-lvn-bundle-compare]');
        cmp.textContent = formatMoney(unit * qty, data.moneyFormat);
        cmp.hidden = qty <= buy;
      });
      if (form && first) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) { idInput.value = first.id; idInput.disabled = !first.available; }
        const btn = form.querySelector('[name="add"]');
        const allOk = rows.every((r) => { const v = rowVariant(r); return v && v.available; });
        if (btn) btn.disabled = !allOk;
      }
      return first;
    };

    const buildRows = (bar) => {
      const box = bar.querySelector('[data-lvn-bundle-rows]');
      const prev = $$(el, '.lvn-bundle__row').map((r) => $$(r, 'select').map((s) => s.value));
      $$(el, '[data-lvn-bundle-rows]').forEach((b) => (b.innerHTML = ''));
      if (!rowTpl || data.options.length === 0 || (data.variants.length === 1 && data.options[0] === 'Title')) return;
      const qty = Number(bar.dataset.qty);
      if (labels) {
        const l = labels.cloneNode(true);
        l.hidden = false;
        box.appendChild(l);
      }
      for (let i = 0; i < qty; i++) {
        const row = rowTpl.content.firstElementChild.cloneNode(true);
        if (qty > 1) row.querySelector('.lvn-bundle__row-num').textContent = `#${i + 1}`;
        const values = prev[i] || prev[0];
        if (values) $$(row, 'select').forEach((s, j) => { if (values[j] !== undefined) s.value = values[j]; });
        box.appendChild(row);
      }
      if (labels && qty > 1) box.firstElementChild.querySelector('.lvn-bundle__row-num').textContent = '#';
    };

    bars.forEach((bar) => {
      bar.addEventListener('click', (event) => {
        if (event.target.closest('select')) return;
        if (bar.classList.contains('is-active')) return;
        bars.forEach((b) => b.classList.toggle('is-active', b === bar));
        bar.querySelector('input[type="radio"]').checked = true;
        buildRows(bar);
        refresh();
      });
    });
    el.addEventListener('change', (event) => {
      if (!event.target.matches('select')) return;
      const first = refresh();
      // la 1re ligne pilote la galerie (même logique que le sélecteur de variantes Dawn)
      const row = event.target.closest('.lvn-bundle__row');
      if (first && row === activeBar().querySelector('.lvn-bundle__row') && first.media) {
        const gallery = document.querySelector(`[id^="MediaGallery-${el.dataset.section}"]`);
        if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(`${el.dataset.section}-${first.media}`, true);
      }
    });
    buildRows(activeBar());
    refresh();

    if (!form) return;
    // Capture : passe avant le gestionnaire <product-form> de Dawn pour ajouter toutes les lignes d'un coup.
    document.addEventListener('submit', async (event) => {
      if (event.target !== form) return;
      const rows = $$(activeBar(), '.lvn-bundle__row');
      if (!rows.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const counts = new Map();
      for (const row of rows) {
        const v = rowVariant(row);
        if (!v || !v.available) return;
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
      }
      const btn = form.querySelector('[name="add"]');
      btn && btn.classList.add('loading');
      btn && btn.setAttribute('aria-disabled', 'true');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [...counts].map(([id, quantity]) => ({ id, quantity })) };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      try {
        const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const json = await res.json();
        if (!res.ok || json.status) {
          const msg = form.closest('product-form')?.querySelector('.product-form__error-message');
          if (msg) { msg.textContent = json.description || json.message || 'Erreur'; msg.closest('[role="alert"]').hidden = false; }
          return;
        }
        if (cart && cart.renderContents && json.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(json);
        } else {
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        }
      } catch (e) {
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      } finally {
        btn && btn.classList.remove('loading');
        btn && btn.removeAttribute('aria-disabled');
      }
    }, true);
  });

  const init = (root = document) => {
    initCarousels(root);
    initVideos(root);
    initReviews(root);
    initCollection(root);
    initDelivery(root);
    initBundles(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
